// extracted by mini-css-extract-plugin
export default {"models":"ModelsTab_models__tR7d1","block":"ModelsTab_block__c2C0F","modelSettings":"ModelsTab_modelSettings__eisPE"};